import React from 'react';
import { Button } from 'components/shadcn/ui/button';
import { PencilIcon, PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useFormikContext } from 'formik';
import HGStatus from 'components/HGStatus';
import SerialNumberInput from 'components/HGForm/SerialNumberInput';
import { useValidateDevices } from '../helper';
import { useLocation } from 'react-router-dom';

const NewDeviceInputRow = () => {
    const { values, setFieldValue } = useFormikContext();
    const Thing_ID = useLocation().pathname.split('/')[2];
    const validateDevice = useValidateDevices(Thing_ID, values.newDevices);

    const validate = (index) => {
        const newDevices = validateDevice(index);
        setFieldValue('newDevices', newDevices);
    };

    return (
        <>
            {values?.newDevices?.map((newDevice, index) => (
                <tr key={index}>
                    <td>
                        <HGStatus online={newDevice.status ?? 'pending'} />
                    </td>
                    <td>
                        {newDevice.status ? (
                            newDevice.serialNumber
                        ) : (
                            <SerialNumberInput
                                label="Serial Number"
                                name={`newDevices[${index}].serialNumber`}
                                placeholder="Enter Serial Number"
                                sx={{ minHeight: 0 }}
                            />
                        )}
                    </td>

                    <td>Microinverter</td>
                    <td>
                        <div className="flex justify-end">
                            {newDevice.status ? (
                                <Button
                                    variant="outline"
                                    size="sm"
                                    className="min-w-[35px] p-0"
                                    onClick={() => {
                                        setFieldValue(
                                            `newDevices[${index}].status`,
                                            ''
                                        );
                                    }}
                                >
                                    <PencilIcon className="w-4 h-4" />
                                </Button>
                            ) : (
                                <Button
                                    variant="outline"
                                    size="sm"
                                    className="min-w-[35px] p-0"
                                    onClick={() => validate(index)}
                                >
                                    <PlusIcon className="w-4 h-4" />
                                </Button>
                            )}
                            <Button
                                variant="outline"
                                size="sm"
                                className="min-w-[35px] p-0 ml-1"
                                onClick={() => {
                                    setFieldValue('newDevices', [
                                        ...values.newDevices.filter(
                                            (_, i) => i !== index
                                        ),
                                    ]);
                                }}
                            >
                                <XMarkIcon className="w-4 h-4" />
                            </Button>
                        </div>
                    </td>
                </tr>
            ))}
        </>
    );
};

export default NewDeviceInputRow;
